import axios from "axios";

import {
  ResponseFile,
  ResponseItem,
  ResponseList,
  ResponseRemove,
} from "../../models/clientModels/interfaces/Response";
import * as Params from "../../models/clientModels/interfaces/apiParams";
import {EQUser, userListParams} from "../../models/serverModels/EQUser";

const rootApi = process.env.REACT_APP_API_KEY;

const user = axios.create({
  baseURL: rootApi,
});

export const login = async (params: Params.Auth): Promise<ResponseItem<EQUser>> =>
  axios({
    url: "/API/Login",
    method: "post",
    data: params,
  }).then((res) => res.data);

export const getList = async (params: userListParams): Promise<ResponseList<EQUser>> =>
  user({
    url: "/UserList",
    method: "get",
    params,
  }).then((res) => res.data);

export const getItem = async (params: Params.GetItem): Promise<ResponseItem<EQUser>> =>
  user({
    url: `/User/${params.id}`,
    method: "get",
    params,
  }).then((res) => res.data);

export const create = async (params: Params.Create<EQUser>): Promise<ResponseItem<EQUser>> =>
  user({
    url: `/User/`,
    method: "post",
    data: params,
  }).then((res) => res.data);

export const remove = async (params: Params.Remove): Promise<ResponseRemove> =>
  user({
    url: `/User/${params.id}`,
    method: "delete",
    data: params,
  }).then((res) => res.data);

export const update = async (params: Params.Update<EQUser>): Promise<ResponseItem<EQUser>> =>
  user({
    url: `/User/${params.id}`,
    method: "put",
    data: params,
  }).then((res) => res.data);

export const importUsers = async (params: Params.ImportFile): Promise<ResponseFile> =>
  user({
    url: `/ImportUsers`,
    method: "post",
    data: params,
  }).then((res) => res.data);

// BoardManagerList
export const BoardManagerList = async (params: Params.GetList): Promise<ResponseList<EQUser>> =>
  user({
    url: "/BoardManagerList",
    method: "get",
    params,
  }).then((res) => res.data);
